import { FC } from 'react';

import { Page, PageHeader } from '@/components';
import InternalAffairsTable from '@/pages/Tools/InternalAffairs/Tables/InternalAffairsTable';

const InternalAffair: FC = () => {
  return (
    <Page>
      <PageHeader title="Internal Affairs" backRoute="/tools" />

      <InternalAffairsTable />
    </Page>
  );
};

export default InternalAffair;
